export default "__VITE_ASSET__CQFPAatB__"